<template>
  <!--
      作者：kmdshop
      时间：2019-10-25
      描述：订单列表
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="订单号"><el-input size="small" v-model="searchForm.order_no" placeholder="请输入订单号"></el-input></el-form-item>
        <el-form-item label="产品名称"><el-input size="small" v-model="searchForm.product_name" placeholder="请输入产品名称"></el-input></el-form-item>
        <el-form-item label="配送方式">
          <el-select size="small" v-model="searchForm.style_id" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in exStyle" :key="index" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="门店列表">
          <el-select size="small" v-model="searchForm.store_id" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in shopList" :key="index" :label="item.store_name" :value="item.store_id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="物流中心" v-if="is_open_logistics">
          <el-select size="small" v-model="searchForm.logistics_id" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in logisticsList" :key="index" :label="item.name" :value="item.logistics_id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              size="small"
              v-model="searchForm.create_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>
         <el-form-item label="导出方式">
          <el-select size="small" v-model="searchForm.export_type" placeholder="请选择">
            <el-option label="按订单" value=""></el-option>
            <el-option label="按产品" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="float: right;">
          <el-button size="small" type="warning" @click="showBatchDelivery" v-auth="'/order/order/operate/batchDelivery'">批量发货</el-button>
        </el-form-item>

        <el-form-item><el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit"  v-auth="'/order/order/operate/search'">查询</el-button></el-form-item>
        <el-form-item><el-button size="small" type="success" @click="onExport"  v-auth="'/order/order/operate/export'">导出</el-button></el-form-item>
        <el-form-item><el-button size="small" type="primary" @click="importOrder"  v-auth="'/order/order/operate/import'">导入</el-button></el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部订单" name="all"></el-tab-pane>
          <el-tab-pane :label="'未付款(' + order_count.payment + ')'" name="payment"></el-tab-pane>
          <el-tab-pane :label="'待发货(' + order_count.delivery + ')'" name="delivery"></el-tab-pane>
          <el-tab-pane :label="'待收货/已发货(' + order_count.received + ')'" name="received"></el-tab-pane>
          <el-tab-pane label="待评价" name="comment"></el-tab-pane>
          <el-tab-pane label="已完成" name="six"></el-tab-pane>
          <el-tab-pane label="取消订单" name="canceling"></el-tab-pane>
          <el-tab-pane label="已取消" name="cancel"></el-tab-pane>
        </el-tabs>
        <el-table size="small" :data="tableData.data" :span-method="arraySpanMethod" border style="width: 100%" v-loading="loading">
          <!-- <el-table-column type="selection"></el-table-column> -->
          <el-table-column prop="order_no" label="订单信息" width="400" >
            <template slot-scope="scope">
              <div class="order-code" v-if="scope.row.is_top_row">
                <span class="state-text" :class="{'state-text-red':scope.row.order_source != 10}">{{scope.row.order_source_text}}</span>

                <span class="c_main hand" @click="handleCopy(scope.row.order_no, $event)">订单号：{{ scope.row.order_no }}</span>
                <span class="pl16">下单时间：{{ scope.row.create_time }}</span>
              </div>
              <template v-else>
                  <div class="product-info" v-for="(item, index) in scope.row.product" :key="index" 
                   >
                  <div class="pic"><img v-img-url="item.image?item.image.file_path:''" alt="" /></div>
                  <div class="info">
                    <div class="name gray3 product-name">
                      <span>{{ item.product_name }}</span>
                    </div>
                    <div class="gray9" v-if="item.product_attr">{{ item.product_attr }}</div>
                  </div>
                  <div class="d-c-c d-c">
                    <div class="orange">￥ {{ item.product_price }}</div>
                    <div class="gray3">x{{ item.total_num }}</div>
                  </div>
                </div>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="pay_price" label="实付款">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div class="orange">{{ scope.row.pay_price }}</div>
              <p class="gray9">(含运费：{{ scope.row.express_price }})</p>
            </template>
          </el-table-column>
          <el-table-column prop="" label="买家">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div>{{ scope.row.user?scope.row.user.nickName:'' }}</div>
              <div class="gray9">ID：({{ scope.row.user? scope.row.user.user_id:'' }})</div>
            </template>
          </el-table-column>
          <el-table-column prop="state_text" label="交易状态">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              {{ scope.row.state_text }}
            </template>
          </el-table-column>
          <el-table-column prop="pay_type.text" label="支付方式">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span class="gray9">{{ scope.row.pay_type.text }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="delivery_type.text" label="配送方式">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span class="green">{{ scope.row.delivery_type.text }}</span>
              <span v-if="scope.row.delivery_type.value == 30">手机号:{{scope.row.user?scope.row.user.mobile:''}}</span>
              <br />
              <span v-if="scope.row.reserve_date||scope.row.reserve_time">预约时间:{{scope.row.reserve_date?scope.row.reserve_date:''}} {{scope.row.reserve_time?scope.row.reserve_time:''}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="is_comment" label="评价" width="60">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span v-if="scope.row.is_comment == 0">未评价</span>
              <span v-else>已评价</span>
            </template>
          </el-table-column>
          <el-table-column prop="logistics" label="发货仓库" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.logistics">{{ scope.row.logistics.name }}({{ scope.row.logistics.logistics_id }})</span>
              <span v-else>平台</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="130">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <el-button v-if="(supply_id>0&&supply_setting.order_detail>0||supply_id==0)" @click="addClick(scope.row)" type="text" size="small" v-auth="'/order/order/detail'">订单详情</el-button>
          <!-- 取消订单按钮 -->
          <el-button
            v-if=" scope.row.order_status.value == 10
              && (supply_id>0&&supply_setting.order_cancel>0||supply_id==0)"
            @click="handleCancelOrder(scope.row)"
            type="text"
            size="small"
            style="color: #f56c6c;"
      
          >
            取消订单
          </el-button>

              
              <el-button
                v-if="(scope.row.pay_status.value == 20 && scope.row.delivery_status.value == 10
                && scope.row.order_status.value != 20 && scope.row.order_status.value != 21
                && scope.row.delivery_type.value != 30)&&(supply_id>0&&supply_setting.order_send>0||supply_id==0)"
                @click="addClick(scope.row)"
                type="text"
                size="small"
                v-auth="'/order/order/delivery'"
              >
                去发货
              </el-button>
              <el-button
                v-if="(scope.row.pay_status.value == 20 && scope.row.delivery_status.value == 10
                && scope.row.order_status.value != 20 && scope.row.order_status.value != 21
                && scope.row.delivery_type.value == 20)&&(supply_id>0&&supply_setting.order_send>0||supply_id==0)"
                @click="addClick(scope.row)"
                type="text"
                size="small"
                v-auth="'/order/order/operate/extract'"
              >
                去核销
              </el-button>
              <el-button v-if="scope.row.order_status.value == 21&&(supply_id>0&&supply_setting.order_send>0||supply_id==0)" @click="addClick(scope.row)" type="text" size="small" v-auth="'/order/order/operate/confirmCancel'">去审核</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <el-dialog title="批量发货说明" :visible.sync="dialogBatchDelivery" width="30%">
      <div>1、先按未发货条件筛选后，导出订单</div>
      <div>2、在导出excel中填写物流公司、物流单号，然后点批量发货导入填好的excel文件</div>
      <div>3、请检查物流公司是否已经添加到系统，<el-link type="primary" :underline="false" @click="gotoExpress()">查看</el-link>
      </div>
      <div style="padding-top: 20px;padding-bottom: 20px;text-align: center;">
        <el-upload class="avatar-uploader" ref="upload" action="string"
                   accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                   :before-upload="onBeforeUploadImage" :http-request="uploadImage" :show-file-list="false">
          <el-button size="small" icon="el-icon-upload" type="primary">上传发货表格</el-button>
        </el-upload>
      </div>
    </el-dialog>

    <!-- 上传导入组件  -->
    <Upload v-if="open_upload" @closeDialog="closeDialogFunc($event,'upload')"></Upload>

  </div>
</template>

<script>
import OrderApi from '@/api/order.js'
import Upload from '@/components/file/import'
import qs from 'qs'
import clip from '@/utils/clipboard'
export default {
  components:{
    Upload
  },
  data() {
    return {
      /*切换菜单*/
      activeName: 'all',
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        product_name:"",
        export_type:'',
        order_no: '',
        style_id: '',
        store_id: '',
        create_time: ''
      },
      /*配送方式*/
      exStyle: [],
      /*门店列表*/
      shopList: [],
      /* 物流中心 */
      logisticsList:[],
      /* 是否开启物流中心 */
      is_open_logistics:false,
      /*时间*/
      create_time: '',
      /*统计*/
      order_count: {
        payment: 0,
        delivery: 0,
        received: 0
      },
      supply_id:0,
      supply:{},
       open_upload:false,
      // 导入类型
      import_type:'order',
      dialogBatchDelivery: false,
    

    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*跨多列*/
    arraySpanMethod(row) {
      if (row.rowIndex % 2 == 0) {
        if (row.columnIndex === 0) {
          return [1, 8];
        }
      }
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = this.searchForm;
      Params.dataType = self.activeName;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      OrderApi.orderlist(Params, true)
        .then(res => {
          let list = [];
          for (let i = 0; i < res.data.list.data.length; i++) {
            let item = res.data.list.data[i];
            let topitem = {
              order_no: item.order_no,
              create_time: item.create_time,
              order_source:item.order_source,
              order_source_text:item.order_source_text,
              is_top_row: true
            };
            list.push(topitem);
            list.push(item);
          }
          self.tableData.data = list;

          self.totalDataNumber = res.data.list.total;
          self.exStyle = res.data.ex_style;
          self.shopList = res.data.shop_list;
          self.supply_id = res.data.supply_id;
          if(self.supply_id>0){
            self.supply_setting = res.data.supply.kmd_grade.setting;
          }

          console.log(self)
          self.logisticsList = res.data.logistics_list;
          self.is_open_logistics = res.data.is_open_logistics
          self.order_count = res.data.order_count.order_count;
          self.loading = false;
        })
        .catch(error => {});
    },

    /*打开添加*/
    addClick(row) {
      let self = this;
      let params = row.order_id;
      self.$router.push({
        path: '/order/order/Detail',
        query: {
          order_id: params
        }
      });
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    },
    onExport: function() {
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/order.operate/export?' + qs.stringify(this.searchForm);
    },
    // 商品导入
    importOrder:function(row){
      this.open_upload = true
    },
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
        if (f == 'upload') {
            this.open_upload = e.openDialog;
            if (e.type == 'success') {
                  this.getData();
            }
        }
    },
    // 显示批量发货说明
    showBatchDelivery() {
      this.dialogBatchDelivery = true;
    },
    /*跳转物流公司*/
    gotoExpress() {
      let self = this;
      self.$router.push('/setting/express/index');
    },

    /*选择图片之前*/
    onBeforeUploadImage(file) {
      var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const isEXCEL = fileType === 'xlsx';
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isEXCEL) {
        this.$message.error('上传文件只能是excel格式!');
      }
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!');
      }
      return isEXCEL && isLt10M;
    },

    /*上传图片*/
    uploadImage(param) {
      let self = this;
      const loading = this.$loading({
        lock: true,
        text: '正在处理,请等待',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let formData = new FormData();
      formData.append('iFile', param.file);
      OrderApi.batchDelivery(formData)
        .then(response => {
          loading.close();
          self.dialogBatchDelivery = false;
          self.$message({
            message: response.msg,
            type: 'warning'
          });
        })
        .catch(response => {
          loading.close();
          self.$message({
            message: '本次处理失败',
            type: 'warning'
          });
          param.onError();
        });
    },

    handleCopy(text, event) {
      clip(text, event)
    },
    // 取消订单
handleCancelOrder(row) {
  let self = this;
  self.$confirm('确定要取消此订单吗？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    // 调用API取消订单
    OrderApi.cancelOrder({
      order_id: row.order_id
    }).then(res => {
      if (res.code === 1) {
        self.$message({
          type: 'success',
          message: res.msg
        });
        // 刷新列表
        self.getData();
      } else {
        self.$message({
          type: 'error',
          message: res.msg
        });
      }
    }).catch(error => {
      self.$message({
        type: 'error',
        message: '操作失败'
      });
    });
  }).catch(() => {
    // 用户取消操作
  });
}

  }
};
</script>
<style lang="scss" scoped>
.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}
.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}
.order-code .state-text-red{ background: red;}
.table-wrap .product-info:first-of-type {
  border-top: none;
}
.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// src/views/order/order/index.vue